import Datatable from "../../Components/Datatable"
import { useTranslation } from "react-i18next";
import React, { useState, useEffect } from "react";
import { useAuth } from '../../../../../context/AuthContext';
import axios from "axios";
import { API_BASE_URL } from "../../../../../Helpers/apiConfig";

export const AdminCorporateUserList = () => {
    const [managers] = useState([]);

    const { user } = useAuth();
    const [msg, setMsg] = useState([]);
    const [loading, setLoading] = useState(true);

    const { t } = useTranslation()

    const columns = React.useMemo(
        () => [
            {
                Header: t("namesurname"),
                Footer: t("namesurname"),
                accessor: 'name',
            },
            {
                Header: t("email"),
                Footer: t("email"),
                accessor: 'email',
            },
            {
                Header: t("schoolName"),
                Footer: t("schoolName"),
                accessor: 'schoolName',
            },
            {
                Header: t("createdAt"),
                Footer: t("createdAt"),
                accessor: 'createdAt',
            },
            {
                Header: t("expiryDate"),
                Footer: t("expiryDate"),
                accessor: 'expiryDate',
            },
            {
                Header: t("isActive"),
                Footer: t("isActive"),
                accessor: (originalRow) => (
                    <span
                        className={`btn btn-sm ${originalRow.isTrialRaw ? "btn-warning" : "btn-success"}`}
                    >
                        {originalRow.isTrialRaw ? t('passive') : t('active')}
                    </span>
                ),
                id: 'isTrial',
            },
            {
                Header: t("editUser"),
                accessor: (originalRow, rowIndex) => (
                    <div className="d-flex  align-items-center">
                        <button
                            className="btn btn-warning mr-2  btn-sm"
                            onClick={() => handleEdit(originalRow)}
                        >
                            {t("edit")}
                        </button>
                    </div>
                ),
                id: 'actionEdit',
                Footer: t("editUser"),
            },
            {
                Header: t("showSchoolUsers"),
                accessor: (originalRow, rowIndex) => (
                    <div className="d-flex  align-items-center">
                        <button
                            className="btn btn-info mr-2  btn-sm"
                            onClick={() => showSchoolStudents(originalRow)}
                        >
                            {t("showSchoolUsers")}
                        </button>
                    </div>
                ),
                id: 'actionShow',
                Footer: t("showSchoolUsers"),
            },
        ],
        [],
    )
    const handleEdit = (row) => {
        window.location.href = "schooluserlist/editcorporateuser/" + row['id'];

    }
    const showSchoolStudents = (row) => {
        window.location.href = "schooluserlist/" + row['SchoolId'];
    }

    const getManagers = async () => {
        setLoading(true);
        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Authorization': 'Bearer ' + user.token
            }
            let url = `${API_BASE_URL}/admin/User/GetManagers`; // API_BASE_URL kullanımı
            await axios({
                method: 'GET',
                url: url,
                headers: headerss
            }).then(res => {
                if (res.status === 200) {
                    if (res.data['success']) {
                        for (let i = 0; i < res.data['data'].length; i++) {
                            let a = ""
                            if (res.data['data'][i]['user']['isTrial']) {
                                a = t('passive')
                            }
                            else {
                                a = t('active')
                            }
                            const d = new Date(res.data.data[i].user.expiryDate);
                            const expiryDateTR = d.toLocaleDateString("tr-TR");
                            const dd = new Date(res.data.data[i].user.createdAt);
                            const createdDataTR = dd.toLocaleDateString("tr-TR");
                            managers.push({
                                "id": res.data['data'][i]['user']['id'],
                                "name": res.data['data'][i]['user']['fullName'],
                                "email": res.data['data'][i]['user']['username'],
                                "SchoolId": res.data['data'][i]['detail']['schoolId'],
                                "schoolName": res.data['data'][i]['detail']['schoolName'],
                                "isTrial": a,
                                "isTrialRaw": res.data['data'][i]['user']['isTrial'],
                                "expiryDate": expiryDateTR,
                                "createdAt": createdDataTR,
                                "sectionName": res.data['data'][i]['detail']['sectionName'],
                            })
                        }
                    }
                    else {
                        setMsg(res.data['message']);
                    }
                }
                else {
                    setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                }
            });
        }
        catch (err) {
            setMsg(err?.message || "Bir hata oluştu");
        }
        setLoading(false);
    }
    useEffect(() => {
        getManagers();

    }, []);




    return (
        <div>
            <div style={{ textAlign: "center" }}>
                <h1>{t('corporateuserList')}</h1>
                {msg}
            </div>

            {loading && <div>Veriler Yüklenirken Bir Hata Meydana Geldi!</div>}

            {!loading && (
                <div>
                    <Datatable data={managers} columns={columns} tableBaslik={t('managerList')} />
                </div>
            )}

        </div>
    );
};
export default AdminCorporateUserList;
